var chunkMapping = {
	"0": [
		4917
	],
	"76": [
		5035
	],
	"152": [
		5111
	],
	"153": [
		5112
	],
	"156": [
		5115
	],
	"157": [
		5116
	],
	"158": [
		5117
	],
	"159": [
		5118
	],
	"160": [
		5119
	],
	"161": [
		5120
	],
	"162": [
		5121
	],
	"163": [
		5122
	],
	"164": [
		5123
	],
	"165": [
		5124
	],
	"166": [
		5125
	],
	"167": [
		5126
	],
	"168": [
		5127
	],
	"169": [
		5128
	],
	"170": [
		5129
	],
	"171": [
		5130
	],
	"172": [
		5131
	]
};
var idToExternalAndNameMapping = {
	"4917": [
		"default",
		"./Containers",
		3796
	],
	"5035": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5111": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5112": [
		"default",
		"./HostWrapper",
		3796
	],
	"5115": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5116": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5117": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5118": [
		"default",
		"./AuditDialog",
		3796
	],
	"5119": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5120": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5121": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5122": [
		"default",
		"./PaymentModal",
		3796
	],
	"5123": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5124": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5125": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5126": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5127": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5128": [
		"default",
		"./Challenge",
		3796
	],
	"5129": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5130": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5131": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4917": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5035": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5111": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5112": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5115": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5116": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5117": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5118": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5119": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5120": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5121": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5122": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5123": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5124": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}